module.exports = __webpack_public_path__ + "img/github.4995b3c9.svg";